import React, { Fragment, useContext, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSignIn, useSignOut } from "react-auth-kit";
import { downloadFile, sendApiRequest } from "../../services/Base/base-service";
import { notifyUser } from "../../services/helpers";

import PreviewModal from "../Modals/PreviewModal";
import UserContext from "../../store/user-context";
import ConfirmModal from "../Modals/ConfirmModal";
import Breadcrumbs from "./Breadcrumbs";
import { Button, Icon } from "design-react-kit";

import secureLocalStorage from "react-secure-storage";
import DownloadTypeEnum from "../../helpers/Enums/DownloadTypeEnum";

const SubNavigation = ({
  page,
  openModalHandler,
  notificationData,
  setInvalidProperties,
  isVerified,
  setError,
  setIsLoading,
  files,
  documentsNumber,
  phrasesNumber,
  results,
  fixInvalidNotificationF24Handler,
  f24PageNumber,
  readyToBeVerified,
  verifyF24DataNotificationHandler,
  notificationPayments,
  fixNotificationPagoPaPaymentHandler,
  year,
  showStatisticsDetails,
}) => {
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  const edit = secureLocalStorage.getItem("edit");
  const notificationName = secureLocalStorage.getItem(
    "notificationDescription",
  );

  const navigate = useNavigate();
  const signIn = useSignIn();
  const signOut = useSignOut();

  const userContext = useContext(UserContext);

  const params = useParams();
  // const notificationName = params?.name;
  const notificationAttachmentId = params?.notificationAttachmentId;
  const notificationId = params?.id;
  const clientId = params?.clientId;
  const client = params?.client;

  const confirmModalOpenHandler = (e) => {
    setConfirmModalOpen(true);
    setTimeout(() => {
      document.querySelector(".modal-email").textContent = notificationName;
    }, 600);
  };

  const confirmModalCloseHandler = () => {
    setConfirmModalOpen(false);
  };

  const fixInvalidNotificationHandler = () => {
    const inputs = document.querySelectorAll(".error-border");
    inputs.forEach((input) => {
      input.classList.remove("error-border");
      const inputParent = input.closest(".notifEditForm-input.form-group");
      if (inputParent !== null) {
        const errorMessage = inputParent.lastElementChild;
        inputParent.removeChild(errorMessage);
      }
    });
    setError(null);
    setIsLoading(true);
    sendApiRequest(
      `Notification/FixNotification`,
      "POST",
      true,
      {
        invalidNotificationId: notificationId,
        notificationData,
        isVerified,
      },
      signIn,
      signOut,
      navigate,
      null,
      userContext,
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          if (response.data.result === false) {
            notifyUser(
              'La presenza di errori non rende possibile il salvataggio in stato "VERIFICATO" della richiesta di notifica.',
              "error",
              "it-close",
            );
            setInvalidProperties(response.data.invalidProperties);
            setIsLoading(false);
          } else if (response.data.result === true) {
            !isVerified &&
              notifyUser(
                "Richiesta di notifica aggiornata con successo!",
                "success",
                "it-check",
              );

            isVerified &&
              notifyUser(
                "Richiesta di notifica (verificata) aggiornata con successo!",
                "success",
                "it-check",
              );
            setIsLoading(false);
            setTimeout(() => {
              navigate(-1);
            }, 5000);
          }
        }
      }
    });
  };

  const exportResultsHandler = () => {
    const fileResultId = secureLocalStorage.getItem("documentCheckResultId");

    downloadFile(
      { downloadType: DownloadTypeEnum.DocumentCheckResult, fileResultId },
      signIn,
      signOut,
      navigate,
      userContext,
    ).then((response) => {
      if (response.errors === undefined) {
        const fileName = secureLocalStorage.getItem("fileName");
        response.blob().then((blob) => {
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = fileName;
          a.click();
        });
      } else {
        setError([response.errors.message]);
      }
    });
  };

  return (
    <Fragment>
      <div className="w-100 subheader">
        <div className="ml-2 d-flex align-items-center justify-content-between">
          <Breadcrumbs page={page} year={year} />
          {page === "statistics" && showStatisticsDetails && (
            <Button
              outline
              color="#2CB61D"
              className="mr-5 rounded-0 newUser"
              onClick={(e) => {
                navigate("/statistics/details");
              }}
            >
              Visualizza dettaglio mensile
            </Button>
          )}
          {page === "users" && (
            <Button
              outline
              color="#2CB61D"
              className="mr-5 rounded-0 newUser"
              onClick={(e) => openModalHandler()}
            >
              + Nuovo utente
            </Button>
          )}
          {edit && page === "edit" && files?.length > 0 && (
            <div className="d-flex align-items-center justify-content-between">
              <Button
                outline
                color="#D70049"
                className="mr-5 rounded-0 edit-delete"
                onClick={(e) => confirmModalOpenHandler()}
              >
                <Icon
                  icon="it-delete"
                  fill="#d70049"
                  onClick={(e) => confirmModalOpenHandler()}
                ></Icon>{" "}
                Elimina
              </Button>
              <div className="d-flex align-items-center">
                <Button
                  outline
                  className="rounded-0 edit-cancel"
                  onClick={(e) => navigate(-1)}
                >
                  Annulla
                </Button>
                <Button
                  outline
                  color="#2CB61D"
                  className="rounded-0 newUser"
                  onClick={(e) => fixInvalidNotificationHandler()}
                >
                  Salva
                </Button>
              </div>
            </div>
          )}

          {page === "editF24" && files?.length > 0 && (
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                {readyToBeVerified && (
                  <Button
                    outline
                    color="#2CB61D"
                    className="rounded-0 newUser"
                    onClick={(e) => {
                      verifyF24DataNotificationHandler(
                        files[0].notificationPaymentAttachmentId,
                      );
                    }}
                  >
                    Verifica
                  </Button>
                )}
                <Button
                  outline
                  className="rounded-0 edit-cancel"
                  onClick={(e) => navigate(-1)}
                >
                  Annulla
                </Button>
                <Button
                  outline
                  color="#2CB61D"
                  className="rounded-0 newUser"
                  onClick={(e) => {
                    if (notificationData !== null) {
                      fixInvalidNotificationF24Handler(
                        notificationAttachmentId,
                        notificationData,
                        f24PageNumber,
                        notifyUser,
                      );
                    } else if (notificationPayments !== null) {
                      fixNotificationPagoPaPaymentHandler(
                        notificationPayments[0].notificationAttachmentId,
                        notifyUser,
                      );
                    }
                  }}
                >
                  Salva
                </Button>
              </div>
            </div>
          )}
          {page === "clientDocumentsConfiguration" &&
            documentsNumber !== null &&
            documentsNumber > 0 && (
              <Button
                outline
                color="#2CB61D"
                className="mr-5 rounded-0 newUser"
                onClick={(e) => openModalHandler(null)}
              >
                + Aggiungi documento
              </Button>
            )}
          {page === "clientDocumentPhrasesConfiguration" &&
            phrasesNumber !== null &&
            phrasesNumber > 0 && (
              <div className="d-flex">
                <Button
                  color="primary"
                  className="mr-1 rounded-0"
                  style={{ padding: "7px 15px" }}
                  onClick={() => {
                    secureLocalStorage.setItem("edit", null);
                    navigate(
                      `/clientConfiguration/check/${clientId}/${client}`,
                    );
                  }}
                >
                  <Icon icon="it-folder" fill="#fff" className="mr-2" />
                  Verifica configurazione
                </Button>
                <PreviewModal />
                <Button
                  outline
                  color="#2CB61D"
                  className="mr-5 rounded-0 newUser"
                  onClick={(e) => openModalHandler(null)}
                >
                  + Aggiungi campo
                </Button>
              </div>
            )}
          {page === "edit" && !edit && (
            <Button
              outline
              color="#D70049"
              className="mr-5 rounded-0 edit-delete"
              onClick={(e) => confirmModalOpenHandler()}
            >
              <img
                src="./exclude.png"
                alt="Preview"
                className="preview-icon-btn"
              />{" "}
              Escludi dal flusso
            </Button>
          )}
          {page === "check" &&
            results !== null &&
            results.notificationFiles.length > 0 && (
              <Button
                color="primary"
                className="mr-1 rounded-0"
                style={{ padding: "7px 15px" }}
                onClick={() => exportResultsHandler()}
              >
                <Icon icon="it-print" fill="#fff" className="mr-2" />
                Esporta risultati
              </Button>
            )}
        </div>
      </div>
      {edit && (
        <ConfirmModal
          confirmModalOpen={confirmModalOpen}
          confirmModalCloseHandler={confirmModalCloseHandler}
          notifyUser={notifyUser}
          method={"deleteNotificationHandler"}
          text={"Stai per eliminare l'notifica"}
        />
      )}
      {!edit && (
        <ConfirmModal
          confirmModalOpen={confirmModalOpen}
          confirmModalCloseHandler={confirmModalCloseHandler}
          notifyUser={notifyUser}
          method={"excludeNotificationHandler"}
          text={"Stai per escludere la notifica"}
        />
      )}
    </Fragment>
  );
};

export default SubNavigation;
